import {gql} from '@apollo/client'

const EMAIL_SETTINGS_RESULT_FIELDS = `
  success
  errors {
    field
    message
  }
  settings {
    id
    senderName
    senderEmail
    signatureHtml
    emailMode
    emailHost
    emailPort
    emailHostUser
    emailUseTls
    defaultFromEmail
    hasEmailHostPassword
    publicRequireIdentity
  }
`

export const UPDATE_SYSTEM_EMAIL_SETTINGS = gql`
  mutation updateSystemEmailSettings($input: EmailSettingsInput!, $publicRequireIdentity: Boolean) {
    updateSystemEmailSettings(input: $input, publicRequireIdentity: $publicRequireIdentity) {
      ${EMAIL_SETTINGS_RESULT_FIELDS}
    }
  }
`

export const UPDATE_ORGANIZATION_EMAIL_SETTINGS = gql`
  mutation updateOrganizationEmailSettings($organizationId: ID!, $input: EmailSettingsInput!) {
    updateOrganizationEmailSettings(organizationId: $organizationId, input: $input) {
      ${EMAIL_SETTINGS_RESULT_FIELDS}
    }
  }
`

export const UPDATE_USER_EMAIL_SETTINGS = gql`
  mutation updateUserEmailSettings($userId: ID!, $input: EmailSettingsInput!) {
    updateUserEmailSettings(userId: $userId, input: $input) {
      ${EMAIL_SETTINGS_RESULT_FIELDS}
    }
  }
`

export const SEND_TEST_EMAIL = gql`
  mutation sendTestEmail($toEmail: String!, $organizationId: ID, $userId: ID) {
    sendTestEmail(toEmail: $toEmail, organizationId: $organizationId, userId: $userId) {
      success
      errors {
        field
        message
      }
    }
  }
`
